import React from "react";
import { ClientsPage } from "./ClientsPage";
import { useClients } from "./useClients";

function Clients() {
  return <ClientsPage {...useClients()} />;
}

export default Clients;
